import { hasTokenExpired } from './localStorageManager';

const buildAuthHeaders = () => {
  const token = !hasTokenExpired() ? localStorage.getItem('token') : undefined;

  return {
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const getCurrentUser = async (axios) => {
  const headers = buildAuthHeaders();

  const result = await axios.get('/api/get-current-user', headers);

  if (result.status === 200) {
    return result.data.user;
  }
};

export const loginDonator = async (axios, data) => {
  return axios.post('/api/v2/donator/login', { ...data });
};

export const updateDonator = async (axios, data) => {
  const headers = buildAuthHeaders();
  return axios.put('/api/v2/donator', { ...data }, headers);
};

export const getDonation = async (axios, id) => {
  const headers = buildAuthHeaders();
  return axios.get(`/api/v2/donation/${id}`, headers);
};

export const updateDonation = async (axios, id, data) => {
  const headers = buildAuthHeaders();
  return axios.put(`/api/v2/donation/${id}`, { ...data }, headers);
};

export const getDonations = async (axios) => {
  const headers = buildAuthHeaders();
  return axios.get('/api/v2/donation/list', headers);
};

export const getReceipts = async (axios, id) => {
  const headers = buildAuthHeaders();
  return axios.get(`/api/v2/donation/${id}/receipts`, headers);
};

export const forgotPasswordSendEmail = async (axios, email) => {
  const headers = buildAuthHeaders();
  return axios.post(`/api/v2/donator/forgot-password`, { email }, headers);
};

export const resetPassword = async (axios, { token, email, password, passwordConfirmation }) => {
  const headers = buildAuthHeaders();
  return axios.post(`/api/v2/donator/reset-password`, { token, email, password, password_confirmation: passwordConfirmation }, headers);
};

export const getDonationsFromAdmin = async (axios, id) => {
  const headers = buildAuthHeaders();
  return axios.get(`/api/v2/admin/donator/${id}/donations`, headers);
};

export const updateDonatorByAdmin = async (axios, id, data) => {
  const headers = buildAuthHeaders();
  return axios.put(`/api/v2/admin/donator/${id}`, { ...data }, headers);
};

export const updateDonatorPasswordByAdmin = async (axios, id, { password, passwordConfirmation }) => {
  const headers = buildAuthHeaders();
  return axios.patch(`/api/v2/admin/donator/${id}/password`, { password, password_confirmation: passwordConfirmation }, headers);
};

export const createDonatorFromAdmin = async (axios, data) => {
  const headers = buildAuthHeaders();
  return axios.post('/api/v2/admin/donator', { ...data }, headers);
};

export const getDonators = async (axios, params) => {
  const headers = buildAuthHeaders();
  const { page, rowsPerPage, filter, statusFilter } = params;
  return axios.get(`/api/v2/admin/donators?page=${page}&rowsPerPage=${rowsPerPage}&filter=${filter}&statusFilter=${statusFilter}`, headers);
};

// DONATION VALUES 
export const getDonationValues = async (axios) => {
  const headers = buildAuthHeaders();
  return axios.get('/api/v2/donation-value', headers);
};

export const upsertDonationValues = async (axios, data) => {
  const headers = buildAuthHeaders();
  const { id, amount } = data;
  const body = {
    id,
    amount
  };
  return axios.post('/api/v2/admin/donation-value', { ...body }, headers);
};

export const deleteDonationValue = async (axios, id) => {
  const headers = buildAuthHeaders();
  return axios.delete(`/api/v2/admin/donation-value/${id}`, headers);
};

/////////////////////////////////////


// Relationship Rules
export const getRelationshipRules = async (axios) => {
  const headers = buildAuthHeaders();
  return axios.get('/api/v2/admin/relationship-rule', headers);
};

export const upsertRelationshipRule = async (axios, data) => {
  const headers = buildAuthHeaders();
  const {
    id,
    area,
    actions,
    internal_description,
    public_description,
    type
  } = data;

  const body = {
    id,
    area,
    actions,
    internal_description,
    public_description,
    type
  };
  return axios.post('/api/v2/admin/relationship-rule', { ...body }, headers);
};

export const deleteRelationshipRule = async (axios, id) => {
  const headers = buildAuthHeaders();
  return axios.delete(`/api/v2/admin/relationship-rule/${id}`, headers);
};

//////////////////////////////////////////

// EMAIL TEMPLATES
export const getEmailtTemplateByRuleId = async (axios, ruleId) => {
  const headers = buildAuthHeaders();

  return axios.get(`/api/v2/admin/email-template/relationship-rule/${ruleId}`, headers);
};

export const upsertEmailTemplate = async (axios, data) => {
  const headers = buildAuthHeaders();

  const body = {
    id: data.id,
    name: data.name,
    subject: data.subject,
    body: data.body,
    greeting: data.greeting,
    salutation: data.salutation,
    relationship_rule_id: data.relationship_rule_id
  };

  return axios.post('/api/v2/admin/email-template', { ...body }, headers);
};

/////////////////

// DONATION FROM SOURCE 

export const getDonationFromSources = async (axios) => {
  const headers = buildAuthHeaders();
  return axios.get('/api/v2/admin/donation-from-source', headers);
};